<template>
    <div>
        <div>
            <div class="col-xs-12" style="margin-top:4px;" v-if="selected!==null">
                <div style="font-size:smaller;">{{selected.createDateUtc}}</div>
                <div style="white-space:pre-line;color:gray;"> {{selected.msg}} </div>
            </div>
            <div class="col-xs-12" style="text-align:right;">
                <div style="float:left;font-weight:bolder;">Msg</div>
                <textarea type="text" class="form-control" v-model="msg" />
                <span class="btn btn-default" @click="addMsg">Submit</span>
            </div>
            <div class="col-xs-12" style="color:red;text-align:center;">{{errMsg}}</div>
        </div>
        <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="paging">
            <div>


                <div class="col-xs-12" style="margin-top:10px;">
                    <div class="btn btn-default form-control" @click="reload">Refresh</div>
                </div>

                <div class="col-xs-12" v-for="item in items" style="margin-top:4px;cursor:pointer;border:1px solid #ddd;border-radius:10px;padding:10px;" @click="reply(item)">

                    <div>
                        <span class="glyphicon glyphicon-user"></span> <span v-if="item.asker!==null">{{item.asker.givenName }}{{item.asker.surName}}</span>
                        /<span style="color:gray;font-size:smaller;">{{item.createDateUtc}}</span>
                        /<span class="btn btn-default" @click="enquire(item.path,item.query)">{{item.path}}</span>
                    </div>
                    <div style="white-space:pre-line;font-weight:bold;"> {{item.msg}} </div>

                    <div class="col-xs-12" v-for="rp in item.replies" style="margin-top:4px;cursor:pointer;border:1px solid #ddd;">

                        <div style="font-size:smaller;text-align:right;color:#ddd;">{{rp.createDateUtc}}</div>
                        <div style="white-space:pre-line;font-weight:bold;"> {{rp.msg}} </div>

                    </div>

                </div>
            </div>
        </paged-loading>
    </div>
</template>
<script>
    import pagedLoading from '../components/base/PagedLoading.vue';
    import queryString from '../utl/queryString';
    import apis from '../api/extApi.js';

    export default {
        components: {
            pagedLoading: pagedLoading
        },
        props: ["toUserId","pagePath","pageQuery"],
        data: function () {
            return {
                apiClient: apis.api,
                uiClient: apis.ui,
                items: [],
                paging: { page: 1, pageSize: 1, count: 1 },
                loadingImg: false,
                msg: null,
                selected: null,
                errMsg: null,
                editingPostId: null
            };
        },
        methods: {
            enquire: function (path, query) {
                if (path === 'itemdetail') {
                    this.editingPostId = query;
                    this.$emit('onpostselect', query);
                } else {
                    this.editingPostId = null;
                }
            },
            reply: function (item) {
                this.errMsg = null;
                this.selected = item;
            },
            reload: function () {
                this.loadItems();
            },
            addMsg: function () {
                this.errMsg = null;
                if (this.selected === null) {
                    this.errMsg = "Please select a msg to reply!";
                    return;
                }
                this.apiClient.addQAPrms({ toId: this.selected.id, msg: this.msg, toUserId: this.selected.byUserId, path: this.pagePath, query: this.pageQuery })
                    .done((ret) => {
                        this.loadItems();
                    });
            },
            onPageChange: function (newPage) {
                this.paging.page = newPage;
                this.loadItems();
            },
            onSelect: function (file) {
                this.$emit('onselect', file);
            },
            loadItems: function () {
                var obj = { toUserId: this.toUserId, path: this.pagePath, query: this.pageQuery, ...this.paging };
                this.errMsg = null;
                var that = this;
                this.loadingImg = true;
                this.apiClient.getQAPrms(queryString().getString(obj)).done(function (ret) {
                    that.loadingImg = false;
                    var filter = ret.filter;
                    that.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    that.items = ret.items;
                }).fail(function () {
                    that.loadingImg = false;
                });
            }
        },
        created: function () {
            this.loadItems();
        }
    }
</script>